class StickyAddToCart extends HTMLElement {
  /**
   * Initializes the Stick ATC component.
   */
  constructor() {
    super();

    this.ACTIVE_CLASS = "sticky-add-to-cart--active";
    this.triggerElement = document.querySelector(".product__information .button[type='submit']");
    this.qtyInputs = document.querySelectorAll(".product .quantity__input");
  }

  /**
   * Lifecycle method called when the element is added to the DOM.
   */
  connectedCallback() {
    window.addEventListener("scroll", () => this.onScroll(), { passive: true });
    this.onScroll();
    this.addInputListeners();
  }

  /**
   * Handles showing ATC on scroll if triggerElement out of view
   */
  onScroll() {
    const elementBot = this.triggerElement.getBoundingClientRect().bottom;
    const showATC = elementBot < 0;

    showATC
      ? this.classList.add(this.ACTIVE_CLASS)
      : this.classList.remove(this.ACTIVE_CLASS);
  }

  /**
   * Add change event listener to each quantity input
   */
  addInputListeners() {
    this.qtyInputs.forEach((input) => { 
      input.addEventListener("change", () => this.updateInputs(input.value));
    });
  }

  /**
   * Handles syncing across product form inputs
   */
  updateInputs(value) {
    this.qtyInputs.forEach((input) => {
      const wrapper = input.closest("quantity-input");
      const minus = wrapper.querySelector("[data-quantity-button][name='minus']");
      const plus = wrapper.querySelector("[data-quantity-button][name='plus']")
      
      input.value = value;

      if (input.min) {
        const status = value <= parseInt(input.min);
        minus.toggleAttribute('disabled', status);
      }

      if (input.max) {
        const status = value >= parseInt(input.max);
        plus.toggleAttribute('disabled', status);
      }
    });
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}